import { createSwitchNavigator } from 'react-navigation';
import EliteEndSessionConfirm from './EliteEndSessionConfirm';
import EliteLoadingScreen from './EliteLoadingScreen';
import EliteSetupScreen from './EliteSetupScreen';
import EliteUpdateScreen from './EliteUpdateScreen';
import buildWifiNavigator from './wifi/WifiNavigator';
import buildSelectMemberNavigator from './selectmember/SelectMemberNavigator';

const buildEliteNavigator = () => createSwitchNavigator(
  {
    Loading: {
      screen: EliteLoadingScreen,
    },
    Setup: {
      screen: EliteSetupScreen,
    },
    InstallUpdate: {
      screen: EliteUpdateScreen,
    },
    ConfirmSessionEnding: {
      screen: EliteEndSessionConfirm,
    },
    Wifi: {
      screen: buildWifiNavigator(),
    },
    SelectMember: {
      screen: buildSelectMemberNavigator(),
    },
  },
  {
    defaultNavigationOptions: ({ navigation }) => ({
      initialRouteName: 'Loading',
      headerShown: false,
    }),
  },
);

export default buildEliteNavigator;
